import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    totalCostContainer: css({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        boxSizing: "border-box",
        padding: 24,
        width: "100%",
        height: "100%",
        backgroundColor: Color.primary[400],
        color: Color.neutral[0],
        // [theme.breakpoints.down('sm')]: {
        //     padding: 15,
        // }
    }),
    totalCost: css({
        textAlign: "center",
        marginTop: -10
    }),
    // [theme.breakpoints.down('sm')]: {
    //     marginTop: 0,
    // }
});
